import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Building2,
  CheckCircle,
  Target,
  Users,
  Award,
  TrendingUp,
} from "lucide-react";
import CommonContactUs from "./CommonContactUs";

const EmployerBrandingPage = () => {
  return (
    <div className="w-full min-h-screen">
      {/* Hero Section */}
      <section className="bg-[#1A193B] pt-20 text-white">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-3 lg:px-4 py-24 lg:py-32">
          <div className="container mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
                Employer Branding
              </h1>
              <p className="text-xl md:text-2xl text-orange-100 mb-6">
                Build a strong employer brand that attracts top talent_
              </p>
              <p className="text-lg text-orange-200">Our Services</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 px-4 md:px-6 bg-white">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex items-center gap-4 mb-6"
            >
              <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-gradient-to-r from-orange-500 to-red-500 flex-shrink-0">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800">
                Employer Branding Services
              </h2>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-lg text-gray-600 mb-8"
            >
              Our employer branding services help you build a strong employer
              brand that attracts top talent and showcases your company culture.
              We develop strategies that position your organization as an
              employer of choice in the competitive tech talent market.
            </motion.p>

            {/* Services Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bg-gray-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Our Employer Branding Offerings
              </h3>
              <div className="space-y-4">
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Brand Positioning
                    </h4>
                    <p className="text-gray-600">
                      We help you define and articulate your unique employer
                      value proposition, highlighting what makes your company a
                      great place to work and differentiating you from
                      competitors.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Recruitment Marketing
                    </h4>
                    <p className="text-gray-600">
                      Our recruitment marketing strategies help you effectively
                      communicate your employer brand to potential candidates
                      through various channels, including social media, career
                      sites, and industry events.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Candidate Experience
                    </h4>
                    <p className="text-gray-600">
                      We design seamless and positive candidate experiences that
                      reflect your employer brand and leave a lasting
                      impression, even on candidates who aren't hired.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Employer Value Proposition
                    </h4>
                    <p className="text-gray-600">
                      We help you develop a compelling employer value
                      proposition that clearly communicates the benefits of
                      working for your organization, beyond just compensation.
                    </p>
                  </div>
                </div>
                {/* <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Candidate Experience Design
                    </h4>
                    <p className="text-gray-600">
                      Design seamless candidate experiences that reflect your
                      employer brand and create positive impressions throughout
                      the hiring process.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Brand Measurement & Analytics
                    </h4>
                    <p className="text-gray-600">
                      Track and measure the effectiveness of your employer
                      branding efforts with comprehensive analytics and
                      reporting.
                    </p>
                  </div>
                </div> */}
              </div>
            </motion.div>

            {/* Benefits Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="bg-orange-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Benefits of Strong Employer Branding
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                  <Users className="w-5 h-5 text-orange-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Attract Top Talent
                    </h4>
                    <p className="text-gray-600">
                      Stand out in a competitive market and attract high-quality
                      candidates who align with your values.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Target className="w-5 h-5 text-orange-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Reduce Hiring Costs
                    </h4>
                    <p className="text-gray-600">
                      Lower recruitment costs through increased organic
                      applications and reduced time-to-fill.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Award className="w-5 h-5 text-orange-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Improve Retention
                    </h4>
                    <p className="text-gray-600">
                      Employees who connect with your brand are more likely to
                      stay and be engaged.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <TrendingUp className="w-5 h-5 text-orange-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      Enhance Reputation
                    </h4>
                    <p className="text-gray-600">
                      Build a positive reputation that extends beyond
                      recruitment to customers and partners.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div> */}

            {/* Process Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Benefits of Strong Employer Branding
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center font-bold mb-3">
                    1
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                    Attract Top Talent
                  </h4>
                  <p className="text-gray-600">
                    Stand out in a competitive market and attract high-quality
                    candidates who align with your values.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center font-bold mb-3">
                    2
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                    Reduce Hiring Costs
                  </h4>
                  <p className="text-gray-600">
                    Lower recruitment costs through increased organic
                    applications and reduced time-to-fill.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center font-bold mb-3">
                    3
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                    Improve Retention
                  </h4>
                  <p className="text-gray-600">
                    Employees who connect with your brand are more likely to
                    stay and be engaged.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Channels Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              className="bg-gray-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Employer Branding Channels
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-gray-700">Career Website</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-gray-700">LinkedIn</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-gray-700">Glassdoor</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-gray-700">Social Media</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-gray-700">Job Boards</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-orange-600 rounded-full"></div>
                  <span className="text-gray-700">Employee Referrals</span>
                </div>
              </div>
            </motion.div> */}

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="flex justify-center gap-4 flex-wrap"
            >
              <Link to="/services">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-gray-100 text-gray-800 hover:bg-gray-200 px-6 py-3 rounded-lg font-medium transition-colors shadow-md inline-flex items-center"
                >
                  <span>Back to Services</span>
                </motion.button>
              </Link>
              <Link to="/contact">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-lg shadow-lg flex items-center space-x-2 transition-colors duration-300"
                >
                  <Building2 size={18} />
                  <span>Contact Us</span>
                </motion.button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>


      <section className="py-16 bg-[#1A193B] text-white">
        <CommonContactUs/>
      </section>
      {/* Contact Form Section */}
      {/* <section id="employer-branding-contact" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="bg-white p-8 rounded-xl shadow-lg"
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
                Get Started with Employer Branding
              </h2>
              <p className="text-gray-600 mb-8 text-center">
                Ready to build a compelling employer brand? Contact us today to
                discuss your branding needs and objectives.
              </p>

              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Company Name *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                      placeholder="Your company name"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Contact Person *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                      placeholder="Your name"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                      placeholder="email@company.com"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                      placeholder="+1 (234) 567-8910"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Company Size
                    </label>
                    <select className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors">
                      <option value="">Select company size</option>
                      <option value="1-50">1-50 employees</option>
                      <option value="51-200">51-200 employees</option>
                      <option value="201-1000">201-1000 employees</option>
                      <option value="1000+">1000+ employees</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Industry
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                      placeholder="Your industry"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Current Branding Challenges *
                  </label>
                  <textarea
                    required
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                    placeholder="Describe your current employer branding challenges, such as difficulty attracting talent, poor candidate experience, or inconsistent messaging..."
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Branding Goals
                  </label>
                  <textarea
                    rows="3"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
                    placeholder="What specific goals do you want to achieve through employer branding? (e.g., attract specific talent, improve retention, enhance reputation)"
                  />
                </div>

                <div className="text-center">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    type="submit"
                    className="px-8 py-3 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700 transition-colors shadow-lg"
                  >
                    Request Employer Branding Services
                  </motion.button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default EmployerBrandingPage;
